var map = {
	"./ArrowResulsCard.svg": [
		2696,
		696
	],
	"./alreadyVoted.svg": [
		3383,
		383
	],
	"./arrow.svg": [
		7190,
		190
	],
	"./back.svg": [
		9082,
		82
	],
	"./copy.svg": [
		8552,
		552
	],
	"./createVotPopup.svg": [
		7048,
		48
	],
	"./delete-ballot-popup.svg": [
		5236,
		236
	],
	"./eroare-404.svg": [
		6038,
		38
	],
	"./lock.svg": [
		5482,
		482
	],
	"./logo-white.svg": [
		6174,
		174
	],
	"./logo.svg": [
		6962,
		962
	],
	"./noUserStatus.svg": [
		6057,
		57
	],
	"./noVotes.svg": [
		8230,
		849
	],
	"./pencil.svg": [
		184,
		184
	],
	"./pointing.svg": [
		113,
		113
	],
	"./popup.svg": [
		2283,
		283
	],
	"./popupicon.svg": [
		3116,
		116
	],
	"./trash-solid 1.svg": [
		6192,
		192
	],
	"./vote-count.svg": [
		7433,
		433
	],
	"./voteTypes/multipleChoice.svg": [
		7932,
		932
	],
	"./voteTypes/public.svg": [
		4650,
		650
	],
	"./voteTypes/secret.svg": [
		9281,
		281
	],
	"./voteTypes/singleChoice.svg": [
		4424,
		424
	],
	"./votingTemplates/dollar.svg": [
		2380,
		380
	],
	"./votingTemplates/hammer.svg": [
		8147,
		528
	],
	"./votingTemplates/human.svg": [
		7357,
		357
	],
	"./votingTemplates/kebab.svg": [
		8261,
		261
	],
	"./votingTemplates/lynch.svg": [
		3902,
		902
	],
	"./votingTemplates/paper.svg": [
		2400,
		400
	],
	"./votingTemplates/plus.svg": [
		3102,
		102
	],
	"./x.svg": [
		9897,
		897
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1130;
module.exports = webpackAsyncContext;